import { z } from 'zod'

export const createUserFormSchema = z.object({
  lastName: z.string().min(1, { message: 'Поле не может быть пустым' }),
  firstName: z.string().min(1, { message: 'Поле не может быть пустым' }),
  middleName: z.string().default(''),
  email: z
    .string()
    .min(1, { message: 'Поле не может быть пустым' })
    .email({ message: 'Введите корректный email' }),
  companyType: z.string().min(1, { message: 'Поле не может быть пустым' }),
  companyId: z.string().min(1, { message: 'Поле не может быть пустым' }),
  roles: z.array(z.string()).min(1, { message: 'Выберите хотя бы одну роль' }),
})

export type CreateUserFormValues = z.infer<typeof createUserFormSchema>
